module.exports = __webpack_public_path__ + "./fonts/DMSans-BoldItalic.0e8b93.eot";